import React from 'react'
import clsx from 'clsx'
import { CloseIcon } from '@ow/icons'
import { StyledWrapper, StyledIcon } from './styled'

const CloseWrapper = (props) => {
  const {
    allowClear = false,
    hasDropdown = false,
    resetVal,
    onClear,
    children,
  } = props
  const clearHandler = () => {
    if (resetVal) {
      onClear(resetVal)
    } else {
      onClear()
    }
  }
  return (
    <StyledWrapper
      className={clsx(hasDropdown && 'dropDown', 'oc-close-wrapper')}
    >
      {children}
      {allowClear && (
        <StyledIcon onClick={clearHandler} className="clear-icon">
          <CloseIcon
            width={10}
            height={10}
            fill="var(--ow-color-neutral-500)"
          />
        </StyledIcon>
      )}
    </StyledWrapper>
  )
}

export default CloseWrapper
